import { useEffect, useMemo, useState } from "react";

const useMembersPlansState = (members) => {

  const params = useMemo(() =>
    new URLSearchParams(window.location.search),
  [window.location]);

  const [selectedMember, setSelectedMember] = useState();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (params.has("member_uuid")) {
      setReady(false);
      
      const uuid = params.get("member_uuid");
      console.log(`Team member uuid param: ${uuid}`);

      const member = members.find(m => m.uuid === uuid);
      setSelectedMember(member);
    }

    setReady(true);
  }, [params, members]);

  const setMemberUuid = (uuid) => {
    const url = new URL(window.location.href);
    url.searchParams.set("member_uuid", uuid);
    window.location.assign(url);
  }

  return { ready, members, selectedMember, setMemberUuid };
}

export default useMembersPlansState;
